import styled from '@emotion/styled'
import {COLORS} from '../../constants'

/** Left side of the card top row: the chevron plus the identity block. */
export const HeaderLeft = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  flex: 1;
  min-width: 0;
`

/** Square expand/collapse button shown on offers that have sub-offers. */
export const ChevronButton = styled.button`
  margin-top: 2px;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border-radius: 6px;
  border: 1px solid ${COLORS.border};
  background-color: ${COLORS.cardBg};
  color: ${COLORS.mutedText};
  cursor: pointer;

  &:hover {
    background-color: ${COLORS.mutedBg};
  }
`

/** Empty placeholder keeping leaf cards aligned with cards that have a chevron. */
export const ChevronSpacer = styled.span`
  width: 24px;
  flex-shrink: 0;
`

/** Text column holding the title row and the meta row. */
export const Identity = styled.div`
  min-width: 0;
  flex: 1;
`

/** First line of the identity block: offer name and the role/level badges. */
export const TitleRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
`

/** The offer name heading. */
export const OfferName = styled.h3`
  margin: 0;
  min-width: 0;
  font-size: 15px;
  font-weight: 600;
  color: ${COLORS.brand};
  word-break: break-word;
`

/** Pill badge marking the offer as Money Manager or Agent. */
export const RoleBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 500;
  background-color: rgba(0, 122, 255, 0.1);
  color: ${COLORS.brand};
`

/** Pill badge marking the manager's Main Offer (PT-6881). */
export const MainOfferBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  background-color: ${COLORS.brand};
  color: ${COLORS.cardBg};
`

/** Small badge showing the offer's depth in the tree (e.g. "Lvl 2"). */
export const LevelBadge = styled.span`
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 500;
  background-color: #f1f5f9;
  color: ${COLORS.mutedText};
`

/** Second line of the identity block: account id, investor count and AUM. */
export const MetaRow = styled.div`
  margin-top: 4px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 2px 10px;
  font-size: 12px;
  color: ${COLORS.mutedText};
`

/** A single icon-plus-text entry within the meta row. */
export const MetaItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`

/** Assets-under-management figure in the meta row, emphasised in the success colour. */
export const Aum = styled.span`
  font-weight: 500;
  color: ${COLORS.success};
`
